// document.addEventListener('variant:change', function(event){
//   var variant = event.detail.variant;
//   var productId = variant.featured_image.product_id;
//   var $productContainer = document.querySelector('#ProductSection-'+productId);
//   var $mainVariantSelector = $productContainer.querySelector('.product-single__variants');
//   if($mainVariantSelector.querySelector('option[value="'+variant.id+'"]')){
//     if($mainVariantSelector.querySelector('option[value="'+variant.id+'"]').dataset.isPreorder){
//       $productContainer.querySelector('#ProductPreorderMsg-'+productId).classList.remove('hide');
//       setTimeout(function(){ $productContainer.querySelector('#AddToCartText-'+productId).innerHTML = theme.strings.preorder; console.log($productContainer.querySelector('#AddToCartText-'+productId).innerHTML); }, 500);
//     } else {
//       $productContainer.querySelector('#ProductPreorderMsg-'+productId).classList.add('hide');
//     }
//   } else {
//     return;
//   }
// });


jQuery(function($){

});

// var elem = document.querySelector('.main-carousel');
// var flkty = new Flickity( elem, {
//   // options
//   cellAlign: 'left',
//   contain: true,
//   prevNextButtons: false,
//   pageDots: false,
  
// });
// // element argument can be a selector string
// //   for an individual element
// var flkty = new Flickity( '.carousel-nav', {
//   // options
//   asNavFor: '.main-carousel',
//   contain: true,
//   pageDots: false,
//   prevNextButtons: false, 
//   draggable: false
// });

// document.getElementById('search_field').value = '';